export default {
  back: 'Torna alle campagne',
  title: 'Campagna',
  sent_at: 'Inviato {{time}}',
  breakdown_title: 'Riepilogo consegne',
  pending_receipts: {
    title: 'Le statistiche di consegna sono in arrivo',
    description:
      "Questa campagna è appena stata inviata. I provider push confermano la consegna circa 15 minuti dopo l'invio, quindi i dati seguenti saranno disponibili intorno alle {{time}} — nessuna azione richiesta.",
    countdown:
      'Apple e Google confermano le ricevute in circa {{minutes}}m {{seconds}}s (intorno alle {{time}}). Le statistiche si aggiorneranno automaticamente.',
    ready: 'Le ricevute dovrebbero essere disponibili. I dati seguenti si stanno aggiornando.',
    soon: 'a breve',
  },
  recipients: {
    title: 'Destinatari',
    subtitle: 'A chi è stata inviata questa campagna e se ha raggiunto il dispositivo.',
    filters: {
      all: 'Tutti',
      delivered: 'Consegnato',
      pending: 'In attesa di conferma',
      failed: 'Non consegnato',
    },
    columns: {
      recipient: 'Destinatario',
      status: 'Stato',
      reason: 'Motivo',
      clicked: 'Cliccato',
      sent_at: 'Inviato il',
    },
    status: {
      delivered: 'Consegnato',
      pending: 'In attesa di conferma',
      failed: 'Non consegnato',
    },
    reasons: {
      DeviceNotRegistered: 'App rimossa o notifiche disattivate (token scaduto)',
      MessageRateExceeded: 'Temporaneamente limitato da Expo',
      MessageTooBig: 'Payload della notifica troppo grande',
      MismatchSenderId: 'Credenziali push non corrispondenti',
      InvalidCredentials: 'Credenziali push non valide',
      batch_failed: 'Invio batch non riuscito',
      missing_ticket: 'Nessuna conferma ricevuta da Expo',
      unknown: 'Errore di consegna sconosciuto',
    },
  },
};
